module.exports = __webpack_public_path__ + "img/CI.93f28103.svg";